import { useCloneBtnParams } from '@/src/hooks/useCloneBtnParams';
import {
  getContentHomepage_new,
  postContentHomepage_new,
} from '@/src/request/salesChannel/content';
import invokeStrategy, { copyStrategy } from '@/src/strategies/module';
import { randomNumber } from '@/src/tools/helper';
import { modal } from '@/src/utils/Modal';
import { useRequest } from 'ahooks';
import { get, isNull, isString, set, unset } from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { generateContentModule } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import { checkModule } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { useSalesChannelContent } from 'src/hooks/useSalesChannelContent';
import {
  orderKey,
  seoSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepageResponsive/constants';
import { ETextCopyTrigger } from 'src/tools/contentModulesFieldName';
import emit from 'src/tools/event';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EContentEnd, EPreviewSize } from 'src/types/common/SalesChannel';
import { useForms } from './useForms';
import useSaveDraft from './useSaveDraft';
import getNonEditableList from '@/src/strategies/render/not_editable';
import usePreviewService from '@/src/hooks/usePreviewService';
import { useSalesChannelModeWithSister } from 'src/constrains/SalesChannelHOC/useSalesChannel';

// import { generateContentModule } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
// draggableId, visible, moduleType, moduleName,uuid -> OrderFormat
// pc->pcForm
// moduleData = {
//   [draggableId]: {
//     pc,
//     tablet,
//     mobile,
//   },
// };
// }

const useHomepage = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    params,
    salesChannelMultiLanguageQueryParams,
    salesChannel,
    selectedLanguage,
    salesChannelMultiLanguageParams,
  } = useSalesChannelContent();
  const scMode = useSalesChannelModeWithSister();
  const cloneParams = useCloneBtnParams();
  const { contentUuid, saleChannelUuid } = params;
  const _history = useHistory();
  const { onPreview, loading: previewLoading } = usePreviewService();
  // const saleChannelUuid = get(salesChannel, 'uuid');

  const { hasDraft, draft, handleAddDraft, handleDeleteDraft } = useSaveDraft(
    salesChannel?.uuid,
    contentUuid,
    selectedLanguage,
    'homepage',
  );
  const { options } = useContext(ContentModuleGroupPreloadingContext);
  const inUseContentPages = get(options, 'inUsePages') || [];
  const { orderForm, seoSettingForm, pcForm, mobileForm, tabletForm } =
    useForms();
  const moduleData = useRef<any>(null);
  const seoSettingData = useRef<any>(null);
  const copyOfOriginal = useRef<any>(null);
  const isLive =
    get(copyOfOriginal.current, 'salesChannelContent.status') === 'Live';
  const [selectedItem, setSelected] = useState(null);
  const [hasModified, setHasModified] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { run: onSubmit } = useRequest(postContentHomepage_new, {
    manual: true,
    onSuccess: (d) => {
      handleOnDataGet(d);
    },
  });

  const queryParams = salesChannelMultiLanguageQueryParams;
  const submitParams = salesChannelMultiLanguageParams;
  const currentLanguage = useQueryLanguageListContentEditor();

  useEffect(() => {
    // if (beforeRequest) {
    //   beforeRequest();
    // }
    onFetch(queryParams);
  }, [
    currentLanguage, //currentStyle, currentSize
  ]); //每次变化重新抓取数据
  const onFetch = (queryParams) => {
    setLoaded(false);
    _onFetch(queryParams);
  };

  const handleReload = (queryParams) => {
    onFetch(queryParams);
  };

  useEffect(() => {
    window.onbeforeunload = hasModified
      ? async () => {
          const data = submitData();
          await handleAddDraft(selectedLanguage, data?.submitData);
          return 'Saving draft';
        }
      : null;
  }, [hasModified]);
  useEffect(() => {
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const handleDraftLogic = (data) => {
    if (hasDraft && draft?.length) {
      const d = get(draft, '0');
      const salesChannelContent = get(data, 'salesChannelContent');
      set(d, 'salesChannelContent', salesChannelContent);
      modal.info({
        title: getI18n('general.reminder'),
        onOkText: getI18n('general.continue'),
        onOk: () => {
          handleOnDataGet(d?.data);
          setHasModified(true);
        },
        onCancel: () => {
          handleOnDataGet(data);
          handleDeleteDraft();
        },
        content: getI18n('salesChannelContent.index.unsavedVersionTip'),
      });
    } else {
      handleOnDataGet(data);
    }
  };

  const {
    // data,
    loading,
    run: _onFetch,
  } = useRequest(
    (queryParams) => {
      return getContentHomepage_new(contentUuid, queryParams);
    },
    {
      manual: true,
      onSuccess: handleDraftLogic,
    },
  );

  const getCurrentModuleType = () => {
    const order = orderForm.getFieldValue(orderKey) || [];
    const current = order.find((i) => get(i, 'draggableId') === selectedItem);
    return get(current, 'moduleType');
  };

  const handleOnDataGet = (data) => {
    const seoSetting = get(data, 'seoSetting');
    const contentBody = get(data, 'contentBody') || [];
    moduleData.current = handleOnInitialDataToModuleData(contentBody);
    const orderData = handleOnInitOrderData(contentBody);
    copyOfOriginal.current = data;
    seoSettingData.current = seoSetting;
    orderForm.setFieldsValue({ [orderKey]: orderData });
    seoSettingForm.setFieldsValue(seoSetting);
    setSelected('SEO_SETTING');
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  };

  const handleOnPreviousSelectedAssignment = () => {
    const pcValue = pcForm.getFieldsValue();
    const tabletValue = tabletForm.getFieldsValue(true);
    const mobileValue = mobileForm.getFieldsValue(true);
    const draggableId = selectedItem;
    set(moduleData.current, `${draggableId}.${EContentEnd.pc}`, pcValue);
    set(
      moduleData.current,
      `${draggableId}.${EContentEnd.tablet}`,
      tabletValue,
    );
    set(
      moduleData.current,
      `${draggableId}.${EContentEnd.mobile}`,
      mobileValue,
    );
  };

  const handleOnOtherSelectedAssignment = () => {
    if (selectedItem === seoSetting) {
      const v = seoSettingForm.getFieldsValue();
      seoSettingData.current = v;
    }
    //  const pcValue = pcForm.getFieldsValue();
    //  const tabletValue = tabletForm.getFieldsValue();
    //  const mobileValue = mobileForm.getFieldsValue();
    //  const draggableId = selectedItem;

    //  set(moduleData.current, `${draggableId}.${EContentEnd.pc}`, pcValue);
    //  set(
    //    moduleData.current,
    //    `${draggableId}.${EContentEnd.tablet}`,
    //    tabletValue,
    //  );
    //  set(
    //    moduleData.current,
    //    `${draggableId}.${EContentEnd.mobile}`,
    //    mobileValue,
    //  );
  };

  const handleOnSelect = (newSelect) => {
    const handleOnNewSelectModule = () => {
      const nPc = get(moduleData.current, `${newSelect}.${EContentEnd.pc}`);
      const nTa = get(moduleData.current, `${newSelect}.${EContentEnd.tablet}`);
      const nMo = get(moduleData.current, `${newSelect}.${EContentEnd.mobile}`);
      setSelected(newSelect);
      pcForm.resetFields();
      tabletForm.resetFields();
      mobileForm.resetFields();
      pcForm.setFieldsValue(nPc);
      tabletForm.setFieldsValue(nTa);
      mobileForm.setFieldsValue(nMo);
    };

    const handleOnSeoUnselected = () => {
      const seoSetting = seoSettingForm.getFieldsValue();
      seoSettingData.current = seoSetting;
    };

    const handleOnSelectSeo = () => {
      if (newSelect === seoSetting) {
        seoSettingForm.setFieldsValue(seoSettingData.current);
      }

      setSelected(newSelect);
    };
    if (selectedItem !== newSelect) {
      if (selectedItem && selectedItem !== seoSetting) {
        handleOnPreviousSelectedAssignment();
        if (newSelect === seoSetting) {
          handleOnSelectSeo();
        } else {
          handleOnNewSelectModule();
        }
        // handleOnNewSelectModule();
      } else {
        //selectedItem === seoSetting;
        handleOnSeoUnselected();
        handleOnNewSelectModule();
      }
    }
  };

  const handleOnDuplicate = (draggableId, add) => {
    const newDraId = randomNumber();
    handleOnPreviousSelectedAssignment();

    const orderFormValue = orderForm.getFieldValue([orderKey]) || [];
    const valuesInOrderForm = orderFormValue.find(
      (i) => i.draggableId === draggableId,
    );
    const moduleName = valuesInOrderForm?.moduleName;

    const moduleValue = get(moduleData.current, draggableId);
    const pData = get(moduleValue, EContentEnd.pc);
    const tData = get(moduleValue, EContentEnd.tablet);
    const mData = get(moduleValue, EContentEnd.mobile);
    const d = {
      pc: { ...pData, draggableId: newDraId, uuid: null },
      tablet: { ...tData, draggableId: newDraId, uuid: null },
      mobile: { ...mData, draggableId: newDraId, uuid: null },
    };

    const draggableIdN = get(d, 'pc.draggableId');
    const moduleType = get(d, 'pc.moduleType');
    //const uuid = get(d, 'pc.uuid');
    add({ draggableId: draggableIdN, moduleType, moduleName, uuid: null });
    handleOnAdd(d, { moduleName, uuid: null, draggableId: newDraId });
  };

  const handleOnAdd = (nObj, extra?) => {
    const draggableId =
      get(extra, 'draggableId') || get(nObj, 'pc.draggableId');
    const moduleType = get(extra, 'moduleType') || get(nObj, 'pc.moduleType');
    const moduleName = get(extra, 'moduleName') || get(nObj, 'pc.moduleName');
    const data = {
      pc: get(nObj, 'pc'),
      tablet: get(nObj, 'tablet'),
      mobile: get(nObj, 'mobile'),
    };

    const uuid = get(extra, 'uuid') || get(nObj, 'pc.uuid');
    moduleData.current = {
      ...moduleData.current,
      [draggableId]: {
        draggableId,
        moduleType,
        moduleName,
        uuid,
        [EContentEnd.pc]: data?.pc,
        [EContentEnd.tablet]: data?.tablet,
        [EContentEnd.mobile]: data?.mobile,
      },
    };
    handleOnSelect(draggableId);
  };

  const handleOnDelete = (draggableId, extra?) => {
    const { newSelected } = extra || {};

    if (draggableId === selectedItem) {
      if (newSelected) {
        setSelected(newSelected);
      } else {
        setSelected(seoSetting);
      }
    }
    delete moduleData.current[draggableId];
  };

  const onGoBack = () => {
    _history.push(`/salesChannel/content/${saleChannelUuid}`);
  };

  const submitData = () => {
    if (selectedItem === seoSetting) {
      handleOnOtherSelectedAssignment();
    } else {
      handleOnPreviousSelectedAssignment();
    }
    const list = orderForm.getFieldValue(orderKey) || [];
    let flag = null;
    list.forEach((i) => {
      const draggableId = get(i, 'draggableId');
      const moduleType = get(i, 'moduleType');
      const moduleValue = get(moduleData.current, draggableId);
      const pData = get(moduleValue, EContentEnd.pc);
      const tData = get(moduleValue, EContentEnd.tablet);
      const mData = get(moduleValue, EContentEnd.mobile);
      const checkFunc = checkModule(moduleType);
      if (checkFunc) {
        const checkAll = get(checkFunc(), 'checkAll');
        const pR = checkAll(pData, {
          breakpoint: EPreviewSize.WIDE,
          contentPages: inUseContentPages,
        });
        const tR = checkAll(tData, {
          breakpoint: EPreviewSize.TABLET,
          contentPages: inUseContentPages,
        });
        const mR = checkAll(mData, {
          breakpoint: EPreviewSize.MOBILE,
          contentPages: inUseContentPages,
        });
        const hasError =
          get(pR, 'hasError') || get(tR, 'hasError') || get(mR, 'hasError');

        if (hasError) {
          if (!isString(flag)) {
            flag = draggableId;
          }
        }
      }
    });

    const listData = list.map((i) => {
      const draggableId = get(i, 'draggableId');
      const moduleName = get(i, 'moduleName');
      const visible = get(i, 'visible');
      const moduleValue = get(moduleData.current, draggableId);
      return { ...i, ...moduleValue, moduleName, visible };
    });
    const oriData = copyOfOriginal.current;
    const submitData = {
      ...(oriData || {}),
      contentBody: listData,
      seoSetting: seoSettingForm.getFieldsValue(true),
    };
    return {
      submitData,
      flag,
    };
  };

  const handleOnPreview = async () => {
    const data = submitData();
    await onPreview(data.submitData);
  };

  const handleOnSubmit = async () => {
    const data = submitData();
    if (isNull(data?.flag) || !isLive) {
      await onSubmit(data?.submitData, submitParams);
      msg.success(getI18n('general.savesuccess'));
      setHasModified(false);
      await handleDeleteDraft();
    } else {
      modal.error({
        title: getI18n('general.unabletosavechanges'),
        content: getI18n('general.fixerrors'),
        onOk: () => {
          handleOnSelect(data?.flag);
        },
      });
    }
  };

  const handleOnModuleTypeSwitch = (newType) => {
    const preSelected = selectedItem;

    const preDraggableId = get(
      moduleData.current,
      `${preSelected}.draggableId`,
    );
    const preUuid = get(moduleData.current, `${preSelected}.uuid`);

    const nObj = generateContentModule(newType);
    const pV = {
      ...get(nObj, EContentEnd.pc),
      draggableId: preDraggableId,
      uuid: preUuid,
    };
    const tV = {
      ...get(nObj, EContentEnd.tablet),
      draggableId: preDraggableId,
      uuid: preUuid,
    };
    const mV = {
      ...get(nObj, EContentEnd.mobile),
      draggableId: preDraggableId,
      uuid: preUuid,
    };
    //const newDraggableId = get(pV, 'draggableId');
    const newModuleType = get(pV, 'moduleType');
    set(moduleData.current, `${preSelected}.${EContentEnd.pc}`, pV);
    set(moduleData.current, `${preSelected}.${EContentEnd.tablet}`, tV);
    set(moduleData.current, `${preSelected}.${EContentEnd.mobile}`, mV);
    set(moduleData.current, `${preSelected}.moduleType`, newModuleType);

    pcForm.setFieldsValue(pV);
    tabletForm.setFieldsValue(tV);
    mobileForm.setFieldsValue(mV);

    const order = orderForm.getFieldValue(orderKey) || [];
    const index = order.findIndex((i) => get(i, 'draggableId') === preSelected);
    const obj = order.find((i) => get(i, 'draggableId') === preSelected);

    set(order, `${index}`, { ...(obj || {}), moduleType: newModuleType });
    orderForm.setFieldsValue({ [orderKey]: order });

    //orderForm.setFieldsValue([{name:''}])
    // setSelected(newDraggableId);
    // delete moduleData.current[preSelected];
  };

  const handleOnSectionReset = (fields, targetEndSize: EPreviewSize) => {
    const currentModuleType = getCurrentModuleType();
    const defaultData = generateContentModule(currentModuleType);
    const notEditableList = getNonEditableList(currentModuleType);
    if (targetEndSize === EPreviewSize.TABLET) {
      const tabletData = {
        ...get(defaultData, EContentEnd.tablet),
      };
      notEditableList.forEach((fieldName) => unset(tabletData, fieldName));
      const targetData = {};
      fields.forEach((i) => {
        const itemValue = get(tabletData, i);
        if (!!itemValue && JSON.stringify(itemValue) !== '{}') {
          set(targetData, i, itemValue);
        }
      });
      tabletForm.setFieldsValue(targetData);
    }
    if (targetEndSize === EPreviewSize.MOBILE) {
      const mobileData = {
        ...get(defaultData, EContentEnd.mobile),
      };
      notEditableList.forEach((fieldName) => unset(mobileData, fieldName));
      const targetData = {};
      fields.forEach((i) => {
        const itemValue = get(mobileData, i);
        if (!!itemValue && JSON.stringify(itemValue) !== '{}') {
          set(targetData, i, itemValue);
        }
      });
      mobileForm.setFieldsValue(targetData);
    }
  };

  const handleOnSectionCopy = (fields, breakpoint, extra) => {
    const onTextCopyEventPath = get(extra, 'item.onTextCopyEventPath');
    const temp = {};
    const pcData = pcForm.getFieldsValue();
    const tabletData = tabletForm.getFieldsValue();
    const mobileData = mobileForm.getFieldsValue();
    const data = copyStrategy({
      pc: pcData,
      tablet: tabletData,
      mobile: mobileData,
      breakpoint,
    });
    switch (breakpoint) {
      case EPreviewSize.TABLET: {
        fields.forEach((i) => {
          const d = get(data, i);
          set(temp, i, d);
        });
        tabletForm.setFieldsValue(temp);
        if (onTextCopyEventPath) {
          emit.emit(
            ETextCopyTrigger,
            breakpoint,
            get(temp, onTextCopyEventPath),
          );
        }

        break;
      }
      case EPreviewSize.MOBILE: {
        fields.forEach((i) => {
          const d = get(data, i);
          set(temp, i, d);
        });
        mobileForm.setFieldsValue(temp);
        if (onTextCopyEventPath) {
          emit.emit(
            ETextCopyTrigger,
            breakpoint,
            get(temp, onTextCopyEventPath),
          );
        }
        break;
      }
      default:
        return;
    }
  };

  const handlePCFormValuesChange = (changedValues, values) => {
    if (!!get(changedValues, 'moduleType')) {
      const type = get(changedValues, 'moduleType');
      handleOnModuleTypeSwitch(type);
    } else {
      const pcValues = pcForm.getFieldsValue(true);
      const tabletValues = tabletForm.getFieldsValue(true);
      const mobileValues = mobileForm.getFieldsValue(true);
      const data = invokeStrategy({
        changedFields: changedValues,
        pc: pcValues,
        tablet: tabletValues,
        mobile: mobileValues,
      });
      pcForm.setFieldsValue({ ...data?.pc });
      tabletForm.setFieldsValue(data?.tablet);
      mobileForm.setFieldsValue(data?.mobile);
    }
  };

  const handleCloneFromPrimaryLanguage = async () => {
    await onFetch(cloneParams);
    setHasModified(true);
  };

  const handleOnDiscard = async () => {
    // if (hasModified) {
    //   const data = submitData();
    //   await handleAddDraft(selectedLanguage, data?.submitData);
    // }
    onGoBack();
  };

  const handleOnRouteChange = async () => {
    if (hasModified) {
      const data = submitData();
      await handleAddDraft(selectedLanguage, data?.submitData);
    }
  };

  return {
    pcForm,
    mobileForm,
    tabletForm,
    seoSettingForm,
    orderForm,
    data: copyOfOriginal.current,
    salesChannel,
    dataLoading: loading,
    selectedLanguage,
    handleOnSelect,
    handleOnPreview,
    selectedItem,
    handleOnAdd,
    handleOnDelete,
    moduleData: moduleData.current,
    handleOnSubmit,
    handleOnModuleTypeSwitch,
    handleOnSectionReset,
    handleOnSectionCopy,
    handlePCFormValuesChange,
    handleCloneFromPrimaryLanguage,
    handleOnDiscard,
    handleReload,
    hasModified,
    onGoBack,
    setHasModified,
    handleOnDuplicate,
    loaded,
    handleOnRouteChange,
    previewLoading,
    salesChannelMode: scMode,
  };
};
export { useHomepage };

const handleOnInitialDataToModuleData = (data) => {
  return data.reduce((pre, now) => {
    const { draggableId } = now;
    return { ...pre, [draggableId]: now };
  }, {});
};

const handleOnInitOrderData = (data) => {
  const order = data.map((i) => {
    const { draggableId, visible, moduleType, moduleName, uuid } = i;
    return { draggableId, visible, moduleType, moduleName, uuid };
  });
  return order;
};
